import { Button } from 'react-bootstrap';
import ModalTemplate from '../ModalTemplate/ModalTemplate';
import messages from './messages';
import { useIntl } from 'react-intl';

interface OwnProps {
  onClose: () => void;
  onClick: () => void;
}

const UnsavedWarningModal = (props: OwnProps) => {
  const intl = useIntl();

  return (
    <ModalTemplate
      onClose={props.onClose}
      text={intl.formatMessage({ ...messages.warningText })}
      confirmBtn={
        <Button onClick={props.onClick}>
          {intl.formatMessage({ ...messages.confirm })}
        </Button>
      }
    />
  );
};

export default UnsavedWarningModal;
